import { render } from "./mainHeader.vue?vue&type=template&id=f4448c68&scoped=true"
import script from "./mainHeader.vue?vue&type=script&lang=js"
export * from "./mainHeader.vue?vue&type=script&lang=js"

import "./mainHeader.vue?vue&type=style&index=0&id=f4448c68&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\TECHNOVA_FD01\\Desktop\\Augustine\\Projects\\XP\\payout-fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4448c68"]])

export default __exports__